import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import React, { memo } from "react";
import "./MobileTabPicker.css";

interface MobileTabPickerProps {
    label: string;
    currentTab: string;
    onTabSelect: (newTab: string) => void;
    tabs: string[];
    hiddenTabs?: string[];
}

export const MobileTabPicker = memo(({ currentTab, onTabSelect, tabs, hiddenTabs, label }: MobileTabPickerProps) => {
    return (
        <TextField
            className="mobileTabPicker"
            size="small"
            value={currentTab}
            onChange={(event) => onTabSelect(event.target.value as string)}
            label={label}
            variant="outlined"
            select
        >
            {tabs
                .map((tabValue: string) => {
                    if (hiddenTabs?.includes(tabValue)) {
                        return null;
                    }
                    return (
                        <MenuItem key={tabValue} value={tabValue}>
                            {tabValue}
                        </MenuItem>
                    );
                })
                .filter(Boolean)}
        </TextField>
    );
});
